import React from "react";
import { TableSection } from "../../../../components/TableSection";
import { CustomerModel } from "../../../../models/CustomerModels";
import { AveragePaymentTime } from "./AveragePaymentTime";
import { ProductOrderRequirement } from "./ProductOrderRequirement";
import { Description } from "./Description";
import ContactDetails from "./ContactDetails";
import MultipleContactDetails from "./MultipleContactDetails";

type Props = {
  customerDetails: CustomerModel;
};

export function CustomerInsights({ customerDetails }: Props) {
  const tableDefinition = [
    {
      title: "Account Number",
      value: customerDetails.accountNumber,
    },
    {
      title: "Company Name",
      value: customerDetails.companyName,
    },
    {
      title: "Avg Payment Time",
      value: <AveragePaymentTime {...customerDetails.statistics} />,
    },
    {
      title: "Purchase Order",
      value: <ProductOrderRequirement customerDetails={customerDetails} />,
    },
    {
      title: "Description",
      value: <Description customerDetails={customerDetails} />,
    },
    ...(customerDetails.contacts.find((contact) => contact.isPrimary)
      ? [
          {
            title: "Primary Contact",
            value: <ContactDetails contactDetails={customerDetails.contacts.filter((contact) => contact.isPrimary)} />,
          },
        ]
      : []),
    ...(customerDetails.contacts.filter((contact) => !contact.isPrimary).length > 0
      ? [
          {
            title: `Other Contact${customerDetails.contacts.filter((contact) => !contact.isPrimary).length > 1 ? "s" : ""}`,
            value: (
              <MultipleContactDetails
                contactDetails={customerDetails.contacts.filter((contact) => !contact.isPrimary)}
              />
            ),
          },
        ]
      : []),
  ];

  return <TableSection title="Customer" ariaLabel="customer table" tableDefinition={tableDefinition} />;
}
